<template>
  <v-layout>
    <v-row class="pa-0 ma-0 error-404" no-gutters>
      <div class="content">
        <img :src="require('@/assets/img-404.png')" class="img" />
        <h3>Ih rapaz! Não é aqui não</h3>
        <p>Parece que não era isso que você estava procurando, procuramos em todo lugar, mas não conseguimos encontrar o endereço que você digitou.</p>
      </div>
    </v-row>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    env: process.env
  }),
  mounted() {},
  methods: {}
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;
.error-404 {
  height: 100%;
  .content {
    max-width: 390px;
    margin: 0 auto;
    .img {
      display: block;
      margin: 70px auto 0;
      width: 100%;
      max-width: 390px;
    }
    text-align: center;
    h3 {
      font-style: normal;
      font-weight: bold;
      font-size: 28px;
      line-height: 33px;
      text-align: center;
      color: #00b395;
      margin-top: 55px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      letter-spacing: 0.01em;
      color: #6b7580;
      margin-top: 10px;
    }
  }
}

@media screen and (max-width: $phone-size) {
  .error-404 {
    .content {
      padding: 0 20px;
      .img {
        max-width: 100% !important;
      }
      h3 {
        font-size: 24px;
        line-height: 30px;
      }
    }
  }
}
</style>
